import { Component, Inject } from '@angular/core';
import { CMPS_DIALOG_DATA, CmpsDialogRef } from '@cmps/ng-uikit';

import { ActionPickerDialogData } from '../action-picker-dialog-data.model';
import { TranslationKeyMap } from '../gp-main.i18n';

@Component({
    selector: 'cmps-gp-action-picker',
    templateUrl: './action-picker.component.html',
})
export class ActionPickerComponent {
    /** @private */
    _i18n = TranslationKeyMap;

    constructor(
        /** @private */
        readonly _dialogRef: CmpsDialogRef<ActionPickerComponent, void>,
        /** @private */
        @Inject(CMPS_DIALOG_DATA) readonly _data: ActionPickerDialogData,
    ) {}

    _trackByMetric(_: number, m: { metricName: string }): string {
        return m.metricName;
    }
}
